// extracted by mini-css-extract-plugin
module.exports = {"root":"LiveAuctionsPlaceholder_root__3VmF-"};